export default __webpack_public_path__ + "static/medium-image-bimp-2-d3665d28654d25d7267bbef75be836c7.png";